/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Friend_Guest_Today_TitleInputs */

const fr_friend_guest_today_title = /** @type {(inputs: Friend_Guest_Today_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ami(s) invité(s) aujourd'hui`)
};

/**

* @param {Friend_Guest_Today_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const friend_guest_today_title = /** @type {((inputs: Friend_Guest_Today_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friend_Guest_Today_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_friend_guest_today_title(inputs)
});